import React from "react";


function Box1(){
    return(
        <div>
            <div className="box1"> </div>
        </div>
    )
}

export default Box1;